import { render, staticRenderFns } from "./Movimentos-Stock.vue?vue&type=template&id=dbebd6c8&"
import script from "./Movimentos-Stock.vue?vue&type=script&lang=js&"
export * from "./Movimentos-Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports